import { PropsWithChildren } from 'react';

const Form = ({ children, ...restProps }: PropsWithChildren<any>) => {
  return <form {...restProps}>{children}</form>;
};

export default Form;
